import React, { useState, useEffect } from 'react';
import SEO from './SEO';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { MetaInfo } from './Function';
import StickyNotice from './StickyNotice';
import DynamicSlider from './DynamicSlider';
import Logo from '../assets/images/igdtuw-logo.png';
import HeaderBanner from '../assets/images/banner-img.jpg';
import EventBanner from '../assets/images/event-banner.jpg';
import NoticeBanner from '../assets/images/notice-banner.jpg';
import AchievementBanner from '../assets/images/achievement-banner.jpg';
import GlimpsesBanner from '../assets/images/glimpses-banner.jpg';
import DynamicBreadcrumb from './DynamicBreadcrumb';
import { Container,Row,Col } from 'react-bootstrap';

const PageHeader = ({ pageData }) => 
{
    const location = useLocation();
    const currentUrl = decodeURI(`${window.location.origin}${location.pathname}`);
    //const { globalData } = useDataContext();
    const { t } = useTranslation();
    if (global.config.IsPrint === true) { console.info(pageData); }
    const[scrolled, setScrolled] = useState(false);
    const [sp, setPageData] = useState(pageData);
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const [PageType, setPageType] = useState('Webpage');
    const [PageTitle, setPageTitle] = useState('');
    const [PageImage, setPageImage] = useState(HeaderBanner);

    useEffect(() => 
    {
        if (pageData) 
        {
            setPageData(pageData);
            setPageTitle(appLanguage === 'hi' ? pageData.sp_name_hi || pageData.sp_name : pageData.sp_name);
            const image = pageData.headerImage === '' ? HeaderBanner : pageData.headerImage;
            setPageImage(image);
            if (pageData.sp_id === 0) 
            {
                setPageTitle(t(pageData.sp_name));
                switch (pageData.sp_name) 
                {
                    case "EventDetails":
                        setPageType('EventDetails');
                        setPageImage(EventBanner);
                        break;                    
                    case "NoticeDetails":
                        setPageType('NoticeDetails');
                        setPageImage(NoticeBanner);
                        break;
                    case "AchievementDetails":
                        setPageType('AchievementDetails');
                        setPageImage(AchievementBanner);
                        break;
                    case "ExamDetails":
                        setPageType('ExamDetails');
                        setPageImage(NoticeBanner);
                        break;                    
                    case "FacultyDetails":
                        setPageType('FacultyDetails');
                        setPageImage(HeaderBanner);
                        break;
                    case "FacultyPublications":
                        setPageType('FacultyPublications');
                        setPageImage(HeaderBanner);
                        break;
                    case "ClubsSocietiesDetails":
                        setPageType('ClubsSocietiesDetails');
                        setPageImage(HeaderBanner);
                        break;
                    case "GlimpsesDetails":
                        setPageType('Glimpses');
                        setPageImage(GlimpsesBanner);
                        break;
                    case "ProgramDetails":
                        setPageType('ProgramDetails');
                        setPageImage(HeaderBanner);
                        break;
                    default:
                        setPageType('Webpage');
                        setPageImage(HeaderBanner);
                        break;
                }
            }
        }
        const handleScroll = () => 
        {
            const offset = window.scrollY;
            if (offset > 20) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };        
        window.addEventListener('scroll', handleScroll);        
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [pageData, appLanguage, t]);
    
    const GetTitle = MetaInfo(pageData,'sp_meta_title','sp_name',' > ',t);
    const MetaTitle = GetTitle ? `${GetTitle} : ${t('SiteTitle')}` : t('SiteTitle');
    const GetDescription = MetaInfo(pageData,'sp_meta_desc','sp_name',' ',t);
    const MetaDescription = GetDescription ? `${GetDescription}` : t('SiteDescription');
    const GetKeyword = MetaInfo(pageData,'sp_meta_key','sp_name',', ',t);
    const MetaKeyword = GetKeyword ? `${GetKeyword}` : t('SiteKeyword');    
    const schema = {
        "@context": "http://schema.org",
        "@type": (sp?.sp_homepage && sp.sp_homepage === 1) ? "Homepage" : PageType,
        "name": MetaTitle,        
        "description": MetaDescription,
        "url": currentUrl,
        "image": Logo.startsWith('http') ? Logo : `${window.location.origin}${Logo}`,
    };
    const sliderMappings = {
        1: "1",
        33: "2",
        203: "3",
        208: "4",
        235: "6",
        12: "7",
        13: "8",
        14: "9",
        15: "10",
        11: "11",
        16: "12",
        17: "13",
        18: "14",        
        258: "15",
        259: "16",
        260: "17",
        299: "19",
        303: "20",
        310: "23",
        320: "26",
        326: "29",
        337: "31",
        356: "32",
        368: "33",
        374: "34",
        347: "37",
    };
    const [stId, setStId] = useState(sliderMappings[sp.sp_id]);
    useEffect(() => {
        setStId(sliderMappings[sp.sp_id]);
        // eslint-disable-next-line
    }, [sp.sp_id]);

    // Determine if the page should not be indexed
    const noindex = pageData?.sp_id === 0 && pageData?.sp_name === "404 - Page Not Found";
    return (
        <React.Fragment>
            <SEO 
            title={MetaTitle} 
            description={MetaDescription} 
            keyword={MetaKeyword} 
            image={Logo.startsWith('http') ? Logo : `${window.location.origin}${Logo}`} 
            schema={schema} 
            noindex={noindex} />
            <div id='page-header'>
                <div id="page-title" className={`${scrolled ? 'page-title fixed-top' : 'page-title'} ${sp.sp_homepage === 1 ? 'd-none' : ''}`}>
                    <Container>
                        <Row className='align-items-center'>
                            <Col md={5} className='text-start' data-aos="fade-right" data-aos-duration="1500">
                                <h1 className='mb-0 fs-3' >{PageTitle}</h1>
                            </Col>
                            <Col md={7} className='text-end'>
                                <DynamicBreadcrumb pageData={pageData} />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <section className={sp.sp_banner === 1 ? 'd-flex parallax align-items-center justify-content-center' : 'd-none'} style={{ backgroundImage: `url(${PageImage})`}} data-aos="zoom-out" data-aos-duration="1500">                        
                    {stId ? <DynamicSlider stId={stId} /> : <div className='min-height-banner' />}
                </section>
                {sp.sp_sticky_bar === 1 && <StickyNotice />}
            </div>            
        </React.Fragment>
    );
};
export default PageHeader;
